export enum TruckVerificationStatus {
  ElmVerified = 'ELM_VERIFIED',
  ElmFailed = 'ELM_FAILED',
}

export enum TruckClassify {
  AMB = 'AMB',
  Chiller = 'Chiller',
  Frozen = 'Frozen',
}
